import { Box, Grid, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import { WSView } from './WSView';
import dayjs from 'dayjs';
import { WSStatus } from '../Status/WSStatus';
import WSTextField, { CurrencyType, TextType } from '../TextBox/WSTextBox';
import { RegisterOptions } from 'react-hook-form';

// Define an interface for your component props
interface ViewProps {
    labelStyle?: React.CSSProperties;
    header?: string;
    backGroundColor?: string,
    sx?: SxProps<Theme>;
    columns?: IControls[]
}
export interface IControls {
    label: string;
    control: any
    type?: 'TextField' | 'Dropdown' | 'Date' | 'Phone' | 'Email' | 'Radio' | 'CheckBox' | 'FileUpload'
    style?: React.CSSProperties;
    onChange?: (evt: any) => void
    deFaultValue?: any
    name: string
    sm?: number,
    xs?: number,
    rules: any,
    max?: number,
    min?: number,
    currency?: CurrencyType
    options?: Array<any>,
    source?: string
    textType:TextType
}

export const WSHeaderCard: React.FC<ViewProps> = React.memo(({ sx, header, backGroundColor, columns }) => {

    return (
        <Box
        // sx={{
        //     border: '1px solid #ccc',   // Border to give it a card-like appearance
        //     borderRadius: '4px',        // Rounded corners
        //     padding: '0px',             // Inner padding
        //     marginBottom: '16px',       // Spacing from other elements
        // }}
        >
            {/* Header */}
            {header && (
                <Box
                    sx={{
                        backgroundColor: backGroundColor || 'lightgray',
                        padding: '9px',
                        borderRadius: '4px 4px 0 0',  // Rounded top corners
                        marginBottom: '16px',
                        textAlign: 'start',           // Align the header text
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            color: 'black',
                            fontWeight: 'bold',
                            fontSize: '0.875rem'
                        }}
                    >
                        {header}
                    </Typography>
                </Box>
            )}
            {/* <Grid container spacing={2} style={{ paddingLeft: 20, paddingBottom: 10 }}>
                {columns?.map((item: IControls, index: number) => {
                    // Ensure default value for type
                    const type = item?.type || 'none';

                    return (
                        <React.Fragment key={index}>
                            <Grid item sm={item.sm} xs={item.xs}>
                                {type === 'TextField' && (
                                    <WSTextField  currency={item.currency} type={item.textType}   control={item.control}  id={item.name} name={item.name} label={item.label} />
                                )}

                            </Grid>
                        </React.Fragment>
                    );
                })}
            </Grid> */}

        </Box>
    );
});
